import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function usePasswordResetOtpFormValidationScheme() {
  const { getMessage } = useMessageSource();

  const validateOtp = Yup.string().required(
    getMessage("Validation.message-required"),
  );

  return Yup.object().shape({
    emailOtp: validateOtp,
  });
}
